import React, { useContext, useMemo } from "react";
import { useMapData } from "../hooks/useMapData";

export const MapContext = React.createContext();

export const MapProvider = ({ children }) => {
  const mapState = useMapData()
  //console.log("Map state => ", mapState);
  const value = useMemo(() => mapState, [mapState]);
  //console.log("VALUE", value);

  return <MapContext.Provider value={value}>{children}</MapContext.Provider>;
};
export function useMapContext() {
  return useContext(MapContext);
}
